module.exports = __webpack_public_path__ + "img/rt40@2x.ee1fdfc4.png";